import React from 'react';
import { ComponentWithAs, Flex, FlexProps, forwardRef, Heading } from '@chakra-ui/react';
import { ResultProps } from '../../../type';
import MenuResult from '../molecule/MenuResult';

const ResultSection: ComponentWithAs<'div', FlexProps & ResultProps> = forwardRef<FlexProps & ResultProps,
  'div'>((props, ref) => {
  return (
    <Flex ref={ref} {...(props as FlexProps)} direction={'column'} align={'center'} justify={'center'} height={'100%'}>
      <Heading mb={3} color='primary'>
        오늘은
      </Heading>
      <MenuResult food={props.food} />
      <Heading mt={3} color='primary'>
        어때요?
      </Heading>
    </Flex>
  );
});

export default ResultSection;
